import { useIntl } from 'react-intl'
import { KTSVG } from '../../../../../_dashboard/helpers'
import { FC } from 'react';
import { useAuth } from '../../../../modules/auth';

interface Props {
    onAddSlider: () => void; // Updated prop name
  }
  
const PageDetailstoolbarSlider : FC<Props> = ({ onAddSlider }) => { // Updated prop name
  const intl = useIntl();
  const { auth } = useAuth();

  return (
    <div className='d-flex justify-content-end' data-kt-Page-table-toolbar='base'>
      <button
        onClick={onAddSlider}
        className="btn btn-border"
        disabled={auth?.role !== 'ROLE_SUPER_ADMIN'}
      >
        <KTSVG path='/media/icons/duotune/arrows/addicon.svg' className='svg-icon-2' />
        {intl.formatMessage({ id: 'COMMON.ADD_SLIDER' })}
      </button>
    </div>
  )
}

export {PageDetailstoolbarSlider}